import styled from 'styled-components';

export const FormModalContainer = styled.div`
    width: 569px;
    padding: 20px;

    background-color: #000;
    border-radius: 16px;
    border: 1px solid #353535;
    position: relative;

    display: flex;
    justify-content: center;
`;

export const FormModalContent = styled.div`
    width: 350px;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const FormContainer = styled.div`
    width: 100%;
    margin: 12px 0;
`;

export const FormItem = styled.div`
    margin: 0 0 10px 0;
`;

export const Input = styled.input`
    width: 100%;
    height: 40px;
    border-radius: 2px;
    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    padding-left: 15px;
    color: white;
    outline: none;
    margin-bottom: 8px;
    font-size: 14px;

    &:placeholder {
        opacity: 0.5;
    }
`;

export const AddUsersButton = styled.button`
    width: 190px;
    height: 46px;
    border-radius: 100px;
    background-color: #ffffff;
    color: #fc3d40;
    font-weight: 100;
    font-size: 16px;
    cursor: pointer;
    border: none;
    text-transform: uppercase;

    &:hover {
        opacity: 0.75;
    }

    transition: all 0.25s;
`;

export const AddAnotherUserButton = styled.button`
    appearance: none;
    color: #fc3d40;
    font-weight: bold;
    background: none;
    font-size: 16px;
    border: none;
    margin-top: -5px;
    margin-bottom: 20px;
    cursor: pointer;

    &:hover {
        opacity: 0.75;
    }

    transition: all 0.25s;
    outline: none;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddMemberWithEmailModal/style.js